import type { HTMLAttributes, ReactNode } from "react";
import styles from "./alert.module.scss";

export interface AlertProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  variant?: "info" | "success" | "warning" | "error";
  title?: ReactNode;
}

export function Alert({ variant = "info", title, className, children, ...props }: AlertProps) {
  const cls = [styles.alert, styles[variant], className ?? ""].filter(Boolean).join(" ");
  return (
    <div role="alert" className={cls} {...props}>
      <div className={styles.content}>
        {title && <div className={styles.title}>{title}</div>}
        {children}
      </div>
    </div>
  );
}
